export default __webpack_public_path__ + "static/media/Maria_Fiascaris.6857bad3.jpeg";